const TRANSIENT_NODE_KEYS = new Set([
  'selected',
  'dragging',
  'measured',
  'width',
  'height',
  'resizing',
]);

const cleanProperties = (value) => Object.fromEntries(
  Object.entries(value).filter(([key, item]) => !TRANSIENT_NODE_KEYS.has(key) && item !== undefined)
);

export const toReactFlow = (workflow) => ({
  nodes: (workflow?.nodes ?? []).map(({
    id,
    type,
    text,
    risk_id,
    dependency_control_code,
    properties = {},
  }) => ({
    ...properties,
    id,
    type: type || 'actividad',
    position: properties.position ?? { x: 0, y: 0 },
    data: {
      ...(properties.data ?? {}),
      label: text ?? '',
      riskId: risk_id ?? null,
      controlCode: dependency_control_code ?? null,
    },
  })),
  edges: (workflow?.edges ?? []).map(({ id, type, source, target, text, properties = {} }) => ({
    ...properties,
    id,
    type: type || 'transicion',
    source,
    target,
    label: text || undefined,
  })),
  viewport: workflow?.properties?.viewport,
});

export const toApiPayload = ({
  dependencyCode,
  name,
  description,
  nodes,
  edges,
  viewport,
  expectedUpdated,
}) => ({
  dependency_code: dependencyCode,
  name,
  description: description || '',
  properties: { viewport },
  expected_updated: expectedUpdated,
  nodes: nodes.map(({ id, type, data, position, width, height, ...rest }) => {
    const {
      label,
      riskId,
      riskTitle,
      controlCode,
      controlTitle,
      canResize,
      onResizeSwimlane,
      canAddControl,
      onAddControl,
      ...visualData
    } = data ?? {};
    const isSwimlane = visualData.shape === 'swimlane';
    const persistedStyle = isSwimlane
      ? {
          ...(rest.style ?? {}),
          width: width ?? rest.style?.width ?? 1100,
          height: height ?? rest.style?.height ?? 220,
        }
      : rest.style;

    return {
      id,
      type,
      text: label ?? '',
      risk_id: riskId ?? null,
      dependency_control_code: controlCode ?? null,
      properties: cleanProperties({
        ...rest,
        style: persistedStyle,
        position,
        data: visualData,
      }),
    };
  }),
  edges: edges.map(({ id, type, source, target, label, ...rest }) => ({
    id,
    type,
    source,
    target,
    text: typeof label === 'string' ? label : '',
    properties: cleanProperties(rest),
  })),
});
